'use strict';

var _ = require('lodash');
var AdaptiveReoptTooltipFactory = function AdaptiveReoptTooltipFactory() {
  function AdaptiveReoptTooltip() {}
  AdaptiveReoptTooltip.constructor = AdaptiveReoptTooltip;
  function getHtmlContent(cellData, wholeGridData) {
    var completeRow = wholeGridData[cellData.row];
    var tooltipData = {
      runNumberLabel: 'Run Number',
      runNumberValue: completeRow.adaptiveRunNumber,
      notificationCutoffLabel: 'Notification Cutoff',
      notificationCutoffValue: completeRow.adaptiveCutoffTime
    };
    var tooltipContent = _.template(require('../templates/adaptive-reopt-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  AdaptiveReoptTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value === 'ADAPTIVE') {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          noOffset: true,
          placement: 'top'
        };
      }
      return '';
    };
  };
  return AdaptiveReoptTooltip;
};
module.exports = AdaptiveReoptTooltipFactory;